import { Navigate } from "react-router-dom";

// ─── Per-system route slices ──────────────────────────────────────────────────
import { authPublicRoutes } from "./Components/AuthRoutes";
import { coreRoutes } from "./Components/CoreRoutes";

import { hrisRoutes } from "./Components/HRISRoutes";
import { payrollRoutes } from "./Components/PayrollRoutes";

// ─── Assembled route tables ───────────────────────────────────────────────────
export var authProtectedRoutes = [
    ...coreRoutes,

    ...hrisRoutes,
    ...payrollRoutes,

    // Catch-alls — must stay last
    { path: "/", exact: true, component: <Navigate to="/hris/dashboards/employee" /> },
    { path: "*", component: <Navigate to="/pages-coming-soon" /> },
];

export var publicRoutes = [
    ...authPublicRoutes,
];